/** Phase Q — in-app shop notifications (Merchant_Pos) */

export const SHOP_NOTIFICATION_MAX_DROPDOWN_ITEMS = 5;

export const SHOP_NOTIFICATION_RETENTION_DAYS = 30;

const DEFAULT_POLL_MS = 30_000;

export function resolveShopNotificationPollMs(): number {
  // ຖືກເອີ້ນຝັ່ງ browser ດ້ວຍ (notification bell ໃນ Header) —
  // guard `process` ໄວ້ ບໍ່ໃຫ້ crash "process is not defined" ໃນ browser
  const raw =
    typeof process !== "undefined"
      ? process.env.PUBLIC_MERCHANT_NOTIFICATION_POLL_MS
      : undefined;
  if (raw == null || raw === "") return DEFAULT_POLL_MS;
  const n = Number(raw);
  return Number.isFinite(n) && n >= 5_000 ? n : DEFAULT_POLL_MS;
}
